module.exports = __webpack_public_path__ + "img/pay-logo3.4e937a1c.png";